import React, { useEffect, useState } from "react";
import { useUnpaidHoursReasons } from "../../hooks";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

// Define interface for props
interface UnpaidReasonProps {
  text: string | number;
}

// Define interface for the reason item (adjust based on actual hook return type)
interface UnpaidReasonItem {
  id: string | number;
  name: string;
  // Add other properties if they exist
}

const UnpaidReason: React.FC<UnpaidReasonProps> = ({ text }) => {
  // Type the state
  const [type, setType] = useState<string | null>(null);
  // Assume the hook returns items matching UnpaidReasonItem[]
  const unpaid_reasons: UnpaidReasonItem[] = useUnpaidHoursReasons();

  useEffect(() => {
    // Find the reason based on the text prop
    const selected = unpaid_reasons.find((item) => item.id === text);
    if (selected) {
      setType(selected.name);
    } else {
      setType(null); // Explicitly set to null if not found
    }
  }, [unpaid_reasons, text]);

  return type ? (
    <Tooltip title={type}>
      <InfoCircleOutlined />
    </Tooltip>
  ) : null;
};

export default UnpaidReason;
